<div class="dropdown">
  <div
    class="dropdown-header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <div *ngIf="userDetail" fxLayout="row" fxLayoutAlign="start center">
      <div class="dropdown-heading-icon">
        <img [src]="userDetail.profileImageUrl | secureImage | async" alt="" />
      </div>
      <div class="dropdown-heading">
        {{ userDetail.firstName }} {{ userDetail.lastName }}
      </div>
    </div>
  </div>

  <div class="dropdown-content">
    <a
      (click)="close()"
      [routerLink]="'profile'"
      class="notification"
      fxLayout="row"
      fxLayoutAlign="start center"
      matRipple
    >
      <mat-icon
        [icIcon]="icAccountCircle"
        [ngClass]="'text-teal'"
        class="notification-icon"
        fxFlex="none"
      ></mat-icon>
      <div fxFlex="auto">
        <div class="notification-label">
          {{ 'myProfile.title' | translate }}
        </div>
      </div>
    </a>
  </div>

  <div
    class="dropdown-footer"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <a (click)="logout()" color="primary" mat-button>{{
      'general.logout' | translate
    }}</a>
  </div>
</div>
